'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AdminController from './admin.controller';

export default angular.module('conduu.ap.admin.userList', ['conduu.ap.auth', 'ui.router'])
  .config(routes)
  .controller('AdminController', AdminController)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/admin/user-list/index.js